import gql from 'graphql-tag';

const FRAGMENT = gql`
  fragment Univeristy on universities {
    id
    usersub
    due_date
    university_name
    created_at
    schools
    deleted
  }

  fragment Document on documents {
    id
    filename
    url
    status
    university_id
    draft_due_date
    prompt
    type
    count_type
    word_count
    notes
    created_by
  }

  fragment UniversityDetails on universities {
    ...Univeristy
    documents {
      ...Document
    }
  }
`;

export const GET_UNIVERSITIES = gql`
  query getUniversities($usersub: uuid!) {
    universities(
      where: { usersub: { _eq: $usersub }, deleted: { _eq: false } }
      order_by: { due_date: asc }
    ) {
      ...UniversityDetails
    }
  }
  ${FRAGMENT}
`;

export const GET_UPCOMING_DRAFT_ESSAYS = gql`
  query getUniversities($usersub: uuid) {
    universities(
      where: {
        usersub: { _eq: $usersub }
        deleted: { _eq: false }
        documents: {
          status: { _eq: "draft" }
          draft_due_date: { _is_null: false }
        }
      }
      order_by: { due_date: asc }
    ) {
      university_name
      documents(
        where: { status: { _eq: "draft" }, draft_due_date: { _is_null: false } }
      ) {
        draft_due_date
        status
        filename
        url
      }
    }
  }
  ${FRAGMENT}
`;

export const INSERT_UNIVERSITY = gql`
  mutation addUniveristy($data: [universities_insert_input!]!) {
    universities: insert_universities(objects: $data) {
      returning {
        ...UniversityDetails
      }
    }
  }
  ${FRAGMENT}
`;

export const DELETE_UNIVERSITY = gql`
  mutation deleteUniveristy($id: Int!) {
    universities: update_universities(
      where: { id: { _eq: $id } }
      _set: { deleted: true }
    ) {
      returning {
        id
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_UNIVERSITY = gql`
  mutation updateUniveristy($id: Int!, $data: universities_set_input!) {
    universities: update_universities(
      where: { id: { _eq: $id } }
      _set: $data
    ) {
      returning {
        ...UniversityDetails
      }
    }
  }
  ${FRAGMENT}
`;

export const UPDATE_DOCUMENT = gql`
  mutation updateDocument($id: Int!, $data: documents_set_input!) {
    documents: update_documents(where: { id: { _eq: $id } }, _set: $data) {
      returning {
        ...Document
      }
    }
  }
  ${FRAGMENT}
`;

export const ADD_DOCUMENT = gql`
  mutation addDoc($data: documents_insert_input!) {
    row: insert_documents_one(object: $data) {
      ...Document
    }
  }
  ${FRAGMENT}
`;

export const DELETE_DOCUMENT = gql`
  mutation deleteDoc($id: Int!) {
    delete_documents_by_pk(id: $id) {
      id
    }
  }
`;

export const GET_DOCUMENT_LOGS = gql`
  query getDocumentLogs($id: Int!) {
    document_logs(
      where: { university_id: { _eq: $id } }
      order_by: { created_at: asc }
    ) {
      message
      status
    }
  }
`;

export const GET_STATEMENT_LOGS = gql`
  query getDocumentLogs($id: Int!) {
    document_logs(
      where: { personal_statements_id: { _eq: $id } }
      order_by: { created_at: asc }
    ) {
      message
      status
    }
  }
`;
